import ClientSDK from '@hb/wisdom-config-sdk';
import { getCurEnvData } from '../env/env';

const { env } = getCurEnvData();

// 初始化配置sdk
const client = new ClientSDK({
  project: 'appBikeMallH5',
  env: env === 'dev' ? 'fat' : env,
});

export default client;
